/** @format */

import React, { FC, ReactElement, useState } from 'react';
import SimCardInterface from '../../../interfaces/platform/SimCardInterface';
import CardHeader from '../../../components/Heading/CardHeaderExt';
import CellPhone from 'mdi-material-ui/Cellphone';
import CardBody from '../../../components/Card/CardBody';
import Card from '../../../components/Card/Card';
import ActionButton from '../../../components/Buttons/CustomTextButton';
import { AlertDialog } from '../../lib/dialog/AlertDialog';
import { useDispatch } from 'react-redux';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import { operationOnSimcardConstants } from '../../../modules/simcard/operationOnSimcard';

type ProductActivatePreActivatedType = {
    simCard: SimCardInterface;
    reload(): void;
};

export const ProductActivatePreActivated: FC<ProductActivatePreActivatedType> = ({ simCard, reload }): ReactElement => {
    const dispatch = useDispatch();
    const [alertOpen, setAlertOpen] = useState(false);

    const alertConfirmCallback = (): void => {
        const itemLoader = new ItemLoaders(dispatch);
        itemLoader.putWithCallback(
            FormGeneralHelper.getUrl('/operation_on_sim_cards/' + simCard.id),
            operationOnSimcardConstants.SIM_CARD_ACTIVATE_PUT,
            {
                id: simCard.id,
                activate: true,
            },
            (): void => {
                setAlertOpen(false);
                reload();
            },
            { dispatchAfterCallback: false }
        );
    };

    return (
        <Card>
            <CardHeader icon={<CellPhone />} trans="simcard:add.sim_card_is_pre_activate_and_released" />
            <CardBody>
                <ActionButton callback={(): void => setAlertOpen(true)} callbackParam={{}} label="simcard:add.activate_sim_card" size="sm" />
                <AlertDialog
                    open={alertOpen}
                    titleDialog={'simcard:add.confirm_activate_sim_card'}
                    displayMessage={'simcard:add.confirm_activate_esim_sim_card_description'}
                    closeCallback={(): void => {
                        setAlertOpen(false);
                    }}
                    confirmCallback={alertConfirmCallback}
                />
            </CardBody>
        </Card>
    );
};
